<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>意见反馈</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>

    <div class="feedback">
      <textarea name="" id="" cols="30" rows="10" class="txt" placeholder="请提出您宝贵的体验建议，我们将不断优化您的体验。" v-model="textarea"></textarea>
      <input type="telphone" class="input" placeholder="您的手机号（必填）">
      <div class="feedback__upload">
        <div class="word">问题截图（选填，最多上传9张照片）</div>
        <van-uploader v-model="fileList" multiple :max-count="9" />
      </div>
      <div class="form__btn" @click="submitFeedback">提交</div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        fileList: [],
        textarea:''
      }
    },
    mounted() {

    },
    methods: {
      submitFeedback(){
        var $this=this
        if(this.textarea.length>2){
          this.$loading('正在提交')
          setTimeout(function(){
            $this.$toast('提交成功');
          },800)
          setTimeout(function(){
            $this.$router.go(0)
          },1000)
        }else{
          this.$toast('请完善您的宝贵意见');
        }
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .feedback{
  	padding:30*@vm_base;
  	.txt{
  		width:100%;
  		padding:16*@vm_base;
  		background:#fff;
  		border:0;
  		border-radius:6px;
  		font-size:28*@vm_base;
  		color:#333;
  	}
  	.input{
  		margin-top:16*@vm_base;
  		width:100%;
  		padding:20*@vm_base 16*@vm_base;
  		background:#fff;
  		border:0;
  		border-radius:6px;
  		font-size:28*@vm_base;
  		color:#333;
  	}
  	.feedback__upload{
  		// margin-top:16*@vm_base;
      width: calc(100%);
  		padding:16*@vm_base 0 16*@vm_base 16*@vm_base;
  		background:#fff;
  		border-radius:6px;
  		.word{
  			margin-bottom:16*@vm_base;
  			font-size:28*@vm_base;
  			color:#333;
  		}
      
  	}
  }
  .form__btn{
  	width:100%;
  	height:90*@vm_base;
  	line-height:90*@vm_base;
  	margin-top:80*@vm_base;
  	background:linear-gradient(132deg,rgba(116,114,114,1) 0%,rgba(59,53,53,1) 100%);
  	border-radius:3px;
  	text-align:center;
  	font-size:34*@vm_base;
  	font-family:PingFangSC-Regular,PingFang SC;
  	font-weight:400;
  	color:rgba(255,255,255,1);
  }

</style>



// WEBPACK FOOTER //
// src/components/feedback/feedback.vue